import { formatMoney } from '@/utils/currency';

export const toNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value !== 'string') return 0;

  const sanitizedValue = value.replace(/[^\d,.-]/g, '');
  const lastCommaIndex = sanitizedValue.lastIndexOf(',');
  const lastDotIndex = sanitizedValue.lastIndexOf('.');
  let normalizedValue = sanitizedValue;

  if (lastCommaIndex >= 0 && lastDotIndex >= 0) {
    const decimalSeparator = lastCommaIndex > lastDotIndex ? ',' : '.';
    const thousandSeparator = decimalSeparator === ',' ? /\./g : /,/g;

    normalizedValue = sanitizedValue.replace(thousandSeparator, '').replace(decimalSeparator, '.');
  } else if (lastCommaIndex >= 0) {
    normalizedValue = sanitizedValue.replace(',', '.');
  }

  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const getCheckoutReleaseAmount = (pending, antecipateAmount) =>
  toNumber(pending) + toNumber(antecipateAmount);

export const getPendingWithdrawalsCount = (withdrawals = []) =>
  withdrawals.filter((withdrawal) =>
    ['pending', 'pendente'].includes(String(withdrawal?.status || '').trim().toLowerCase())
  ).length;

export const getCurrencyInputAmount = (value) => {
  const digits = value.replace(/\D/g, '');

  if (!digits) return 0;

  return Number(digits) / 100;
};

export const formatCurrencyInput = (value) => {
  const digits = value.replace(/\D/g, '');

  if (!digits) return '';

  return formatMoney(Number(digits) / 100, 'BRL');
};

export const getDigitalAccountBalance = (acc) =>
  toNumber(
    acc?.available_balance ??
      acc?.availableBalance ??
      acc?.account_balance ??
      acc?.accountBalance ??
      acc?.balance ??
      acc?.saldo_disponivel ??
      acc?.saldoDisponivel
  );

export const formatTransferDate = (date) =>
  new Intl.DateTimeFormat('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
